import PejerBase from 'pejer/src'
import { PejerState } from 'pejer/src/types/base'
import { config } from './config'

export class PejerPay extends PejerBase<typeof config.schema.tables, typeof config.urls> {
  constructor(state: PejerState) {
    super(state)
  }
}
